export default __webpack_public_path__ + "static/media/complete.55780149.svg";